// @ts-nocheck
/* Verbatim port of v1 utilities/defaultUserRolesCompanyCreate.js */
import { USER_ROLES, USER_ROLES_MAP } from './constant';

export const DEFAULT_USER_ROLE_CHOICES = [USER_ROLES.RESELLER, USER_ROLES.COMPANY_ADMIN];

function labelForRole(role) {
  return USER_ROLES_MAP[role] || role;
}

function creatableDefaultUserRoles({
  isSuperAdmin,
  isCompanyAdmin,
  creatorAssignedIsOwnCompany,
  isReseller,
  loggedUserParent,
  loggedUserSuperParent,
  loggedUserSuperSuperParent,
  isCreatingEndUserCompany,
}) {
  const roles = [];

  if (isCreatingEndUserCompany) {
    if (isSuperAdmin) {
      roles.push(USER_ROLES.COMPANY_ADMIN);
      return roles;
    }
    if (isReseller && !creatorAssignedIsOwnCompany) {
      roles.push(USER_ROLES.COMPANY_ADMIN);
    }
    if (isCompanyAdmin && !creatorAssignedIsOwnCompany) {
      const companyUserChainFull =
        loggedUserParent === USER_ROLES.COMPANY_ADMIN &&
        loggedUserSuperParent === USER_ROLES.COMPANY_ADMIN &&
        loggedUserSuperSuperParent === USER_ROLES.COMPANY_ADMIN;
      if (!companyUserChainFull) {
        roles.push(USER_ROLES.COMPANY_ADMIN);
      }
    }
    return roles;
  }

  if (isSuperAdmin) {
    roles.push(USER_ROLES.RESELLER);
    return roles;
  }

  if (isCompanyAdmin && !creatorAssignedIsOwnCompany) {
    const companyUserChainFull =
      loggedUserParent === USER_ROLES.COMPANY_ADMIN &&
      loggedUserSuperParent === USER_ROLES.COMPANY_ADMIN &&
      loggedUserSuperSuperParent === USER_ROLES.COMPANY_ADMIN;
    if (!companyUserChainFull) {
      roles.push(USER_ROLES.COMPANY_ADMIN);
    }
  }

  if (isReseller && !creatorAssignedIsOwnCompany) {
    if (
      loggedUserParent === USER_ROLES.RESELLER &&
      loggedUserSuperParent === USER_ROLES.RESELLER &&
      loggedUserSuperSuperParent === USER_ROLES.RESELLER
    ) {
      roles.push(USER_ROLES.COMPANY_ADMIN);
    } else {
      roles.push(USER_ROLES.RESELLER, USER_ROLES.COMPANY_ADMIN);
    }
  }

  return roles;
}

export function getDefaultUserRolesForCompanyCreate({
  isSuperAdmin,
  isCompanyAdmin,
  creatorAssignedIsOwnCompany,
  isCallCenterAdmin,
  isReseller,
  loggedUserParent,
  loggedUserSuperParent,
  loggedUserSuperSuperParent,
  isCreatingResellerCompany,
  isCreatingEndUserCompany,
}) {
  if (!isCreatingResellerCompany && !isCreatingEndUserCompany) {
    return [];
  }

  const creatable = creatableDefaultUserRoles({
    isSuperAdmin,
    isCompanyAdmin,
    creatorAssignedIsOwnCompany,
    isReseller,
    loggedUserParent,
    loggedUserSuperParent,
    loggedUserSuperSuperParent,
    isCreatingEndUserCompany: Boolean(isCreatingEndUserCompany),
  });

  const allowed = new Set(DEFAULT_USER_ROLE_CHOICES);
  const seen = new Set();
  const out = [];

  for (const role of DEFAULT_USER_ROLE_CHOICES) {
    if (!allowed.has(role) || !creatable.includes(role) || seen.has(role)) continue;
    seen.add(role);
    out.push({ value: role, label: labelForRole(role) });
  }

  return out;
}
